import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5e41efab"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  ref: "canvasContainer",
  style: {
    "position": "relative",
    "height": "100vh",
    "width": "100%"
  }
};
var _hoisted_2 = {
  ref: "canvas",
  style: {
    "border": "1px solid black",
    "position": "absolute"
  }
};
var _hoisted_3 = {
  style: {
    "position": "absolute",
    "top": "10px",
    "left": "10px"
  }
};
var _hoisted_4 = {
  "class": "tools"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h5", null, "Tools", -1);
});
var _hoisted_6 = {
  "class": "container"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", null, "Color", -1);
});
var _hoisted_8 = {
  "class": "container"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", null, "Brush Size", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("canvas", _hoisted_2, null, 512)], 512), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
    "class": "download",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.download && $options.download.apply($options, arguments);
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-download",
    "class": "download-icon"
  }), _createTextVNode(" Export As PNG")]), _createElementVNode("button", {
    "class": "savebutton",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.save && $options.save.apply($options, arguments);
    })
  }, "Save"), _createElementVNode("button", {
    "class": "cancelbutton",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      _ctx.$store.commit('updateShowDrawingPad', false);
    })
  }, "Cancel"), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _withDirectives(_createElementVNode("input", {
    type: "color",
    "class": "colorselector",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.color = $event;
    })
  }, null, 512), [[_vModelText, $data.color]])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _withDirectives(_createElementVNode("input", {
    type: "range",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.brushSize = $event;
    }),
    min: "1",
    max: "50"
  }, null, 512), [[_vModelText, $data.brushSize]])])])])]);
}